
<template>
<section>
  <div class="columns">
    <div class="col">
      <chc-input v-model="data.company_name" label="Company Name" :required="true" :error="errors.company_name"></chc-input>
      <chc-input v-model="data.address_street" label="Mailing Address" :required="true" :error="errors.address_street"></chc-input>
      <chc-input v-model="data.address_city" label="City" :required="true" :error="errors.address_city"></chc-input>
      <chc-input v-model="data.address_state" label="State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list" :required="true" :error="errors.address_state"></chc-input>
      <chc-input v-model="data.address_zip" label="Zip" format="zip" :required="true" :error="errors.address_zip"></chc-input>
      <chc-input v-model="data.email" label="Email Address" :required="true" :error="errors.email"></chc-input>
      <chc-input v-model="data.phone" label="Phone" :required="true" :error="errors.phone"></chc-input>
      <h3>Fees</h3>
      <chc-input v-model="data.default_auction_fee_cents" label="Default Auction Fee" format="currency"></chc-input>
      <chc-input v-model="data.default_conditioning_fee_cents" label="Default Miscellaneous Fee" format="currency"></chc-input>
      <chc-input v-model="data.preferred_towing_company_id" label="Preferred Towing Company"
                 :autoCompleteValues="$store.state.towingCompanies.towingCompaniesList" format="combo"></chc-input>
      <h3>Default Towing Destination <a href="#" @click="copyTowingAddress">Copy Company Address</a></h3>
      <chc-input v-model="data.towing_address_street" label="Address" ref="towingAddress" :error="errors.towing_address_street"></chc-input>
      <chc-input v-model="data.towing_address_city" label="City" :error="errors.towing_address_city"></chc-input>
      <chc-input v-model="data.towing_address_state" label="State" format="combo"
                 :autoCompleteValues="$store.state.constants.us_states_list" :error="errors.towing_address_state"></chc-input>
      <chc-input v-model="data.towing_address_zip" label="Zip" format="zip" :error="errors.towing_address_zip"></chc-input>
      <div class="field left">
        <p v-if="hasErrors" class="error-message">
          There were errors processing the form. Please fix the fields above.
        </p>
        <input @click="submit" type="submit" class="btn" value="Save Changes">
      </div>
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'

export default {
  name: 'BuyerAdd',
  data () {
    return {
      data: {
        company_name: '',
        address_street: '',
        address_city: '',
        address_state: '',
        address_zip: '',
        email: '',
        phone: '',
        default_auction_fee_cents: '',
        default_conditioning_fee_cents: '',
        preferred_towing_company_id: null,
        towing_address_street: '',
        towing_address_city: '',
        towing_address_state: '',
        towing_address_zip: '',
        status: 'active'
      },
      errors: [],
      hasErrors: false,
    }
  },
  props: ['companyName'],
  mounted () {
    if (this.companyName) this.data.company_name = this.companyName
  },
  methods: {
    submit () {
      store.functions.buyers.createBuyer(this.data, (errors) => {
        this.errors = errors
        this.hasErrors = true
      })
        .then((response) => {
          // this.$router.push({name: 'BuyersSummary'})
          this.$emit('refresh', {'buyer': response.data})
          this.$emit('close')
        })
    },
    copyTowingAddress () {
      this.$refs.towingAddress.forceUpdateValue(this.data.address_street)
      this.data.towing_address_city = this.data.address_city
      this.data.towing_address_state = this.data.address_state
      this.data.towing_address_zip = this.data.address_zip
    }
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
  h3 > a {
    font-weight: 400;
    font-size: .875rem;
    margin-left: 2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Buyer/BuyerAdd.vue